import { CustomColormapLegend } from "@/components/organisms/CustomColormapLegend/CustomColormapLegend";
import { t } from "@lingui/core/macro";
import type { ColormapCreate } from "@mm/metx-workbench.meteomatics.com";
import { ErrorBoundary } from "react-error-boundary";
import styles from "./MapLegend.module.scss";

const FULL_SIZE_STYLE = { width: "100%", height: "100%" } as const;

export type CustomColormapMapLegendProps = {
  parameter: string;
  customColormap: ColormapCreate;
  legendUnit?: string;
};

const CustomColormapMapLegendImpl = ({ parameter, customColormap, legendUnit }: CustomColormapMapLegendProps) => {
  const unit = legendUnit ?? parameter.split(":")[1] ?? "";

  return (
    <div className={styles["map-legend"]}>
      <CustomColormapLegend
        colormap={customColormap}
        title={customColormap.label || undefined}
        unit={unit}
        barWidth={10}
        barHeight={310}
        style={FULL_SIZE_STYLE}
        panelPadding={{ x: 0, y: 10 }}
      />
    </div>
  );
};

export const CustomColormapMapLegend = ({ parameter, customColormap, legendUnit }: CustomColormapMapLegendProps) => {
  return (
    <ErrorBoundary
      fallbackRender={() => <div className={styles["map-legend"]}>{t`Custom legend unavailable`}</div>}
      onError={(error, info) => console.error("Custom colormap legend error:", error, info)}
      resetKeys={[
        parameter,
        legendUnit,
        customColormap.label,
        customColormap.type,
        JSON.stringify(customColormap.stops),
      ]}
    >
      <CustomColormapMapLegendImpl parameter={parameter} customColormap={customColormap} legendUnit={legendUnit} />
    </ErrorBoundary>
  );
};
